import { render, staticRenderFns } from "./EditEmployer.vue?vue&type=template&id=2064f001&"
import script from "./EditEmployer.vue?vue&type=script&lang=ts&"
export * from "./EditEmployer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports